import styled from 'styled-components';

const Button = styled.button`
  font-size: 18px; border: none; padding: 8px 12px;
  background: var(--skin-color); border-radius: 4px;
  color: #000;
  cursor:pointer;
`;

export { Button }